module.exports = __webpack_public_path__ + "static/media/profileIcon.2ef55437.svg";